import moment from 'moment';

export const relativeTimeConverter = (timeSlot) => {
  if(timeSlot.time.split(":")[0] >= 12) {
    return { ...timeSlot, time: moment(timeSlot.time, ['HH:mm']) }
  } else {
    return { ...timeSlot, time: moment(timeSlot.time, ['HH:mm']).add(1, 'day') }
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js